
// const hideValues = false

import ApiService from './ApiService'

class AIService {
  request = async (apiToken, userId, submissionId, action) => {
    let url = '/ai/query/' + action

    if (!userId || !submissionId || !action) { return }
    
    let params = {}
    params.userId = userId
    params.submissionId = submissionId

    let body = {}

    try {
      // Need to change this to a POST
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }

    return response
  }

  getPrompts = async (apiToken, section) => {
    let url = '/ai/prompts'
    let params = {
      section: section
    }
    let body = {}
    try {
      var response = await ApiService.get(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  } 

  askAboutIncident = async (apiToken, userId, submissionId, promptId) => {
    let url = '/ai/ask/incident/' + promptId

    if (!userId || !submissionId || !promptId) { return }
    
    let params = {}
    params.userId = userId
    params.submissionId = submissionId

    let body = {}

    try {
      // Need to change this to a POST
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }

    return response
  }

  askAboutStudent = async (apiToken, userId, promptId) => {
    let url = '/ai/ask/student/' + promptId

    if (!userId || !promptId) { return }
    
    let params = {}
    params.userId = userId

    let body = {}
    try {
      // Need to change this to a POST
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }
  askAboutService = async (apiToken, promptId) => {
    let url = '/ai/ask/service/' + promptId

    if (!promptId) { return }
    
    let params = {}
    let body = {}

    try {
      // Need to change this to a POST
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }
  syncService = async (apiToken) => {
    let url = '/ai/sync/service'
 
    let params = {}

    let body = {}

    try {
      // Need to change this to a POST
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }

}
export default new AIService()
